import { render, staticRenderFns } from "./indexAir.vue?vue&type=template&id=5df5104c"
import script from "./indexAir.vue?vue&type=script&lang=js"
export * from "./indexAir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5df5104c')) {
      api.createRecord('5df5104c', component.options)
    } else {
      api.reload('5df5104c', component.options)
    }
    module.hot.accept("./indexAir.vue?vue&type=template&id=5df5104c", function () {
      api.rerender('5df5104c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/main/indexAir.vue"
export default component.exports